import React, { useState, useEffect, useRef, useCallback } from 'react';
import { StyleSheet, View, TouchableOpacity, ScrollView, Text, Image, Platform, Dimensions, Modal, Linking } from 'react-native';
//import { Input, Button } from 'react-native-elements';
import { useForm, Controller, FormProvider } from 'react-hook-form';
import TextField from '../controls/TextBox';
import NumberField from '../controls/NumberField';
import PaperDates from '../controls/datePicker-paperDates';
//import { DropdownControl, MultiDropdownControl } from '../controls/Dropdown-sharingan-rn';
import ButtonControl from '../controls/Button';
import { createItem, updateItem, triggerWorkflow } from '../service/dataOperations';
import { useAuth } from '../../../../providers/AuthProvider';
import { useClient } from '../../../../providers/ClientProvider';
import NotificationBanner, { NotificationType } from '../controls/NotificationBanner';
import * as ExpoDocumentPicker from 'expo-document-picker'
import * as FileSystem from 'expo-file-system';
import * as Permissions from 'expo-permissions';
import DocPicker from '../controls/DocPicker';
import { IconButton, Tooltip, MD3Colors, Portal } from 'react-native-paper';
import { BlurView } from 'expo-blur';
import formCustomStyles from './formStyles';
import { useNav } from '../../../../providers/NavProvider';
import { getObjectByID } from '../../../../services/Utils';
import WebView from 'react-native-webview';
import * as Location from 'expo-location'
import CameraScreen from '../controls/CameraControl';
import LocationField from '../controls/LocationBox';
import { Loader } from '../../../Common/Loader';
import { ConfirmTop } from '../../../Common/ConfirmBoxTop';
import MaterialDropdown from '../controls/Dropdown-Single';
import ReactDropdownMultiSelect from '../controls/Dropdown-Multi';
import { margin } from 'polished';
import { logStyles } from '../../LogControllers/LogStyles';
import ReactDropdownSingleSelect from '../controls/Dropdown-Single';
import AttachmentViewerModal from '../../LogControllers/AttachmentViewerModal';
interface PaperFormProps {
  formMode: string;
  fields: Array<any>;
  selectedRow: Array<any>;
  closeForm: () => void;
  siteId: string;
  logTitle: string;
  updateFormState: () => void;
  ItemCreated: (Item: Array<any>) => void;
  Permissions?: string;
  chartVisibility?: (val: boolean) => void;
}

const WebObservationForm: React.FC<PaperFormProps> = React.memo((props) => {

  //console.log("Into Form Comp");
  const editFormFields = ['EscalationNote', 'DateClosedOut', 'ResponsibilityActionBy', 'RootCause', 'ActionTakenByContractor'];
  const [formMode, setFormMode] = useState(props.formMode);
  const [showButtons, setShowButtons] = useState(true);
  const [fields, setFields] = useState(props.fields ?? []);
  const [fileResponse, setFileResponse] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  //const [escalated, setEscalated] = useState<boolean>(null);
  const [fileApi, setFileApi] = useState(null);
  const [itemId, setItemId] = useState(null);
  const [loadForm, setLoadForm] = useState<boolean>(false);
  const [downloadedFileUri, setDownloadedFileUri] = useState(null);
  const [docType, setDocType] = useState(null);
  const [isViewerVisible, setIsViewerVisible] = useState<boolean>(false);
  const [viewerBlob, setViewerBlob] = useState<Blob | null>(null);
  const [viewerFileName, setViewerFileName] = useState<string>("");
  const [viewerLoading, setViewerLoading] = useState<boolean>(false);
  const [docWarning, setDocWarning] = useState<boolean>(null);
  const [warningText, setWarningText] = useState<string>(null);
  const [fileType, setFileType] = useState<string>();
  const screenWidth = Dimensions.get('window').width;
  const screenHeight = Dimensions.get('window').height;
  const [LocationLink, setLocationLink] = useState(null);
  const [fileLoad, setFileLoad] = useState<boolean>(false);
  const [ManualLocation, setManualLocation] = useState<string>("")
  const allowedKeysForGoodPractice = [
    "OriginOfIssue",
    "Contractor",
    "Date",
    "Month",
    "Year",
    "Location",
    "Category",
    "ObservationType",
    "ObservationDescription",
    "RaisedBy",
    "Attachments"
  ];
  // Single source of truth for "is this field applicable right now" — used both to decide
  // what renders and (in onSubmit) what gets nulled out when it becomes inapplicable, so the
  // two can't drift apart.
  function isFieldApplicable(field: any, observationType: string, closedOut: string): boolean {
    if (observationType === "Good Practice/ Strong Point") {
      return allowedKeysForGoodPractice.includes(field.key);
    }
    if (editFormFields.includes(field.key) && field.key !== 'EscalationNote') {
      return closedOut === "Yes";
    }
    return field.hidden !== true;
  }

  let escalated: boolean = null;
  //const [uploadedFiles, setUploadedFiles] = useState(JSON.parse(column.defaultValue));
  let item: any;
  //let fileApi:string


  // const newFormFields = props.fields && props.fields.filter(field => !editFormFields.includes(field.key));
  // if (formMode === 'Edit' || formMode === 'View') {
  //   setFields(props.fields);
  // }
  // else{
  //   setFields(newFormFields);
  // }

  useEffect(() => {

    let formFields = props.fields;
    if (formMode === 'Edit' || formMode === 'View') {
      item = props.selectedRow[0] && props.selectedRow[0];
      formFields = item && (fields ?? []).map((field) => {
        //const defaultValue = field.subType === 'date'? returnDate(item[field.key]) : item[field.key];
        const defaultValue = item[field.key] && item[field.key];
        return { ...field, defaultValue };
      });
      const AttachmentColumn = formFields && (formFields ?? []).find((c) => c.subType === "attachment");
      if (AttachmentColumn && AttachmentColumn.defaultValue) {
        setUploadedFiles(JSON.parse(AttachmentColumn.defaultValue));
      }
      const LocationColumn = (formFields ?? []).find((c) => c.key === "Location");
      if (LocationColumn && LocationColumn.defaultValue && LocationColumn.defaultValue.includes('coords')) {
        let LocLinks = JSON.parse(LocationColumn.defaultValue)        //LocationColumn.defaultValue;
        if (LocLinks.coords && LocLinks.coords.latitude && LocLinks.coords.longitude) {
          setLocationLink(LocLinks);

          let updatedFields = (formFields ?? []).map((f: any) => {
            if (f.key === "Location") {
              let googleMapLink;
              if (LocLinks && LocLinks.coords && LocLinks.coords.latitude && LocLinks.coords.longitude) {
                //googleMapLink = LocLinks.coords.latitude && LocLinks.coords.longitude && `https://www.google.com/maps/search/?api=1&query=${LocLinks.coords.latitude},${LocLinks.coords.longitude}`;
                googleMapLink = LocLinks.coords.latitude && LocLinks.coords.longitude && `Lattitude, Longitude: ${LocLinks.coords.latitude}, ${LocLinks.coords.longitude}`;
              }
              else {
                googleMapLink = LocLinks
              }
              return { ...f, "defaultValue": JSON.stringify(googleMapLink) };
            }
            return f;
          });
          updatedFields && setFields(updatedFields);
        }
        else {
          formFields && setFields(formFields);
        }
      } else {
        formFields && setFields(formFields);
      }
      item?.ID && setFileApi(encodeURI(clientAPIURL + "api/sites/" + props.siteId + "/lists/" + props.logTitle + "/items/" + item.ID + "/attachments/"));
      item?.Location && setLocationLink(item.Location);
      item?.ID && setItemId(item.ID);
      //setFields(formFields);
      setLoadForm(true);
    }
    else if (formMode === 'New') {
      setLoadForm(true)
    }

  }, [formMode, props.fields]);

  const firstErrorFieldRef = useRef(null);
  const { setValue, handleSubmit, control, watch, reset, formState: { errors } } = useForm();

  const _observationType = watch("ObservationType", "");
  // Fallback only covers the brief gap before the ClosedOut Controller registers — once the
  // field is live, watch() reflects the user's actual selection, so toggling Yes -> No
  // correctly re-hides the closed-out-gated fields via isFieldApplicable below.
  const closedOutDefault = fields.find((f) => f.key === 'ClosedOut')?.defaultValue ?? "";
  const _closedOut = watch("ClosedOut", closedOutDefault);

  React.useEffect(() => {
    if (_observationType === "Good Practice/ Strong Point") {
      setValue("ClosedOut", "Yes");
    } else if (formMode === 'New') {
      setValue("ClosedOut", "No");
    }
    // In Edit/View mode, don't override ClosedOut — preserve the item's saved value
  }, [_observationType, setValue, formMode]);
  React.useEffect(() => {
    if (formMode !== "New") return; // only for new form

    fields.forEach((f) => {
      if (f.subType === "choice" && f.options) {
        const optionsArray = f.options.split("#;#").map((o: string) => o.trim());

        if (optionsArray.length === 1) {
          // only one choice, set it as default
          setValue(f.key, optionsArray[0]);
        }
      }
    });
  }, [fields, formMode, setValue]);
  const methods = useForm();

  const [toastVisibility, setToastVisibility] = useState<boolean>(false)
  const [toastText, setToastText] = useState<string>("");
  const [toastType, setToastType] = useState<NotificationType>('info');

  const { getAccessToken, accessToken, userEmail, userDisplayName } = useAuth();
  const { clientName, clientAPIURL } = useClient();
  const { currentLeafObj, sitesResp } = useNav();
  const Categroy = getObjectByID(currentLeafObj.parentId, sitesResp)
  const PackageName = getObjectByID(Categroy.parentId, sitesResp)
  const [visible, setVisible] = React.useState(false);
  const [CamVisible, setCamVisible] = React.useState(false);
  const showModal = () => setVisible(true);
  const hideModal = () => setVisible(false);
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const [fileId, setFileId] = useState<any>(null);
  function MonthYear(value: Date) {
    if (value) {
      const date = new Date(value);
      const timezoneOffset = 4 * 60; // UTC +4 timezone offset in minutes
      const adjustedDate = new Date(date.getTime() + timezoneOffset * 60000);
      const month = adjustedDate.toLocaleString('en-US', { month: 'short' });
      const year = adjustedDate.getFullYear();
      return month + "-" + year;
    } else {
      return null;
    }
  }
  // Comments is a single free-text column on the backend — instead of letting each editor
  // overwrite the whole history, new text always gets prepended (with an author/timestamp
  // header) above whatever was already stored, so reopen/re-edit cycles keep every entry.
  function buildCommentEntry(authorLabel: string, text: string): string {
    const timestamp = new Date().toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    return `${authorLabel} — ${timestamp}\n${text}`;
  }

  const onSubmit = async (d: any) => {
    setToastText("Submitting...");
    setToastType('submitting');
    setToastVisibility(true);
    setShowButtons(false);
    let ReferenceNumber = null;
    console.log(d);
    debugger;
    let ClosedOut = "No"
    const MonthANDYear = d.Date && d.Date != null ? MonthYear(d.Date) : null;
    //const Location = LocationLink != null ? LocationLink : ManualLocation;
    const Month = MonthANDYear === null ? null : MonthANDYear.split('-')[0];
    const Year = MonthANDYear === null ? null : MonthANDYear.split('-')[1];
    //if (d.ObservationType !== null || d.ObservationType !== undefined) 
    //{
    ReferenceNumber = d.ObservationType == "Good Practice/ Strong Point" ? "GPR" : "ENVO";
    ClosedOut = d.ObservationType == "Good Practice/ Strong Point" ? "Yes" : d.ClosedOut;
    //}

    const uploadedFilesJson = JSON.stringify(uploadedFiles);
    let status = escalated === true ? "Escalated" : (d.ClosedOut === "Yes" || ClosedOut === "Yes") ? "Closed" : formMode === 'New' ? "Submitted" : "Re-Submitted";
    const data = { ...d, 'Attachments': uploadedFilesJson, 'Status': status, ReferenceNumber, Month, Year, ClosedOut };

    const commentsField = fields.find((f) => f.key === 'Comments');
    if (commentsField) {
      const newCommentText = (d.NewComment || '').trim();
      const existingComments = (commentsField.defaultValue as string) || '';
      if (newCommentText) {
        const authorLabel = userDisplayName || userEmail || 'Unknown user';
        const entry = buildCommentEntry(authorLabel, newCommentText);
        data.Comments = existingComments ? `${entry}\n\n${existingComments}` : entry;
      } else {
        data.Comments = existingComments;
      }
      delete data.NewComment;
    }

    // System-computed fields set directly above — never gated by isFieldApplicable, since
    // e.g. ClosedOut/Status must always be sent regardless of ObservationType/ClosedOut state
    // (this branch's Good Practice allowlist doesn't include ClosedOut, unlike the fields it gates).
    const systemFields = ['Status', 'ReferenceNumber', 'ClosedOut', 'Month', 'Year', 'Attachments'];

    // Nullify fields that just became inapplicable (per the same rule used for rendering), so
    // a stale hidden value — e.g. an old DateClosedOut from before ClosedOut was switched back
    // to No, or a RootCause left over from before switching to Good Practice — doesn't
    // silently persist and resurface next time this record is reopened. Comments is an
    // append-only history, handled separately above; schema-hidden columns and systemFields
    // are unrelated to this workflow gating; and only fields that already had real data from
    // this form are touched, so schema entries with no matching render case (e.g. a
    // frontend-only "ID" field) are never swept in.
    fields.forEach((f) => {
      if (f.key === 'Comments' || f.hidden === true || systemFields.includes(f.key)) return;
      if (!(f.key in data)) return;
      if (!isFieldApplicable(f, data.ObservationType, data.ClosedOut)) {
        data[f.key] = null;
      }
    });

    //setD(JSON.stringify(data));
    let oItem = data;
    const result = Object.keys(data).map((key) => {
      const column = fields.find((c) => c.key === key);
      if (!column) return null;
      const dataType = column.datatype.toLowerCase();
      // "calculated" fields (e.g. ID) are frontend-only/backend-computed — there's no real
      // column for them, so they must never be sent in a create/update payload.
      if (dataType === 'calculated') return null;

      const value = data[key];
      if (dataType === 'datetimes') {
        delete oItem.key;
        oItem = { ...oItem, key: value };
      }
      //const sanitize = (val: any) =>
      //typeof val === 'string' ? val.replace(/<[^>]*>?/gm, '') : val;

      const formattedValue =
        dataType === 'strings'
          ? value
          : dataType === 'numbers'
            ? Number(value)
            : dataType === 'datetimes'
              ? value
              : null;

      return {
        column_Name: column.key,
        [`${dataType}_Value`]: formattedValue,
        dataype: dataType,
      };
    }).filter((x) => x !== null);

    //console.log(result);
    let response: any;
    try {
      if (formMode === 'Edit') {

        const accessToken = await getAccessToken();
        response = await updateItem(props.logTitle, accessToken, clientAPIURL, props.siteId, itemId, result);
        //console.log(response);
      } else {
        const accessToken = await getAccessToken();
        response = await createItem(props.logTitle, accessToken, clientAPIURL, props.siteId, result);
        //console.log(response);
      }
    }
    catch (err: any) {
      if (err.response?.status === 400) {
        console.error("Error updating item:", err);
        setToastText("Operation Failed: " + err.message);
        setToastType('error');
        setToastVisibility(true);
        setShowButtons(true);
        return;
        //alert(err.response.data); // or err.response.data.message depending on structure
      } else {
        setShowButtons(true);
        setToastText("Something went wrong. Please try again.");
        setToastType('error');
        setToastVisibility(true);
      }
    }

    //if(response.status === 401 || response.statusText === "Unauthorized" || response.statusText === "Bad Request")
    if (!response) {
      setToastText("Operation Failed: You are not authorized to perform this action.");
      setToastType('error');
      setShowButtons(true);
      setToastVisibility(true);
    }
    if (response) {

      if (typeof response === 'number' || response.ok === true) {
        setItemId(response);
        setToastText("Your changes are saved.");
        setToastType('success');
        const accessToken = await getAccessToken();
        if (formMode === "Edit") {
          const result = await triggerWorkflow(currentLeafObj.path, itemId, status, PackageName.title, props.siteId, props.logTitle, clientAPIURL, accessToken)
          //console.log(result);
        }
        else {
          const result = await triggerWorkflow(currentLeafObj.path, response, status, PackageName.title, props.siteId, props.logTitle, clientAPIURL, accessToken)
          //console.log(result);
        }
        setToastVisibility(true);
        setTimeout(function () {
          if (formMode === 'Edit') {
            //const createdItem = oItem && { ...oItem, "ID": itemId, "key": itemId };
            if (oItem) {
              oItem["ID"] = itemId
              oItem["key"] = itemId
            }
            const createdItem = oItem
            props.ItemCreated(createdItem);
          }
          else {
            if (oItem) {
              oItem["ID"] = response
              oItem["key"] = response
            }
            const createdItem = oItem //&& { ...oItem, "ID": response, "key": response };
            props.ItemCreated(createdItem);
          }
        }, 2000)
      }
      else if (response && response.ok === false) {
        setToastText("Operation Failed: One or more inputs contain invalid content.")
        setToastVisibility(true);
        setShowButtons(true);
        return result
      }
    }
    else setShowButtons(true);
  };

  const onError = (errors: any) => {
    const firstErrorKey = Object.keys(errors)[0];
    const errorField = fields.find(f => f.key === firstErrorKey);
    setToastText(`Please fill in the required field: ${errorField?.title || firstErrorKey}`);
    setToastType('error');
    setToastVisibility(true);
    setShowButtons(true);
    if (Platform.OS === 'web') {
      const errorElement = document.getElementById(`field-${firstErrorKey}`);
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  };

  function userTypedLocation(txt: string) {
    // setManualLocation(txt);
    // let updatedFields = (fields ?? []).map((f: any) => {
    //   if (f.key === "Location") {
    //     return { ...f, "defaultValue": txt };
    //   }
    //   return f;
    // });
    // setFields(updatedFields);
    setValue("Location", txt);
  }
  const onFileUploaded = (fileObj: any) => {
    let parsedFileData = JSON.parse(fileObj);
    setUploadedFiles(prevFiles => [...prevFiles, parsedFileData]);
  }
  const [formStyle, setFormStyle] = useState(styles.formContainerMobile);
  function returnDate(value: any) {
    if (value) {
      //const datePattern = /^(\d{2})\/(\d{2})\/(\d{4})$/;
      //if (datePattern.test(value)) 
      {
        //const date = new Date(`${value.split('/')[1]}/${value.split('/')[0]}/${value.split('/')[2]}`);
        const date = new Date(`${value.split('/')[0]}/${value.split('/')[1]}/${value.split('/')[2]}`);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const formattedDate = `${day < 10 ? '0' + day : day}/${month < 10 ? '0' + month : month}/${year}`;
        return formattedDate
      }
    }
    else return value
  }
  const handleClose = () => {
    props.closeForm();
    props.chartVisibility(false);
  }

  const handleToastDismiss = () => {
    setToastVisibility(false);
  };

  const uploadFile = async (fileUri: any) => {
    try {

      const byteCharacters = atob(fileUri);
      const byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      const blob = new Blob(byteArrays, { type: 'application/octet-stream' });
      const file = new File([blob], 'filename.extension', { type: 'application/octet-stream' });
      const formData = new FormData();
      formData.append('file', file);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "multipart/form-data");
      const requestOptions: any = {
        method: 'POST',
        headers: myHeaders,
        body: formData,
        redirect: 'follow',
      };

      const response = await fetch("https://dev-dgda-client-greenport.azurewebsites.net/api/uploadFile", requestOptions);
      const result = await response.text();
      console.log(result);
    } catch (error) {
      console.log('Error uploading file:', error);
    }
  };

  const _pickDocument = async () => {
    let result: any = await ExpoDocumentPicker.getDocumentAsync({});

    if (result.type === 'success') {
      // Read the file contents as binary data
      const fileContent = await FileSystem.readAsStringAsync(result.uri, {
        encoding: FileSystem.EncodingType.Base64,
      });
      const formData: any = new FormData();
      formData.append('file', {
        uri: result.uri,
        name: result.name,
        type: result.type,
        data: fileContent,
      });
      //uploadFile(result.uri);
      console.log(result);
    }
  }
  function ClearLocationText() {
    setLocationLink(null);
    userTypedLocation(" ");
    setValue("Location", " ");
    //setManualLocation(null);//Already we are setting it in userTypedLocation()
    // setTimeout(() => {
    //   userTypedLocation(null);
    // }, 1000);

  }
  function confirmDelete(id: any) {
    setFileId(id)
    showConfirmationBox();
  }
  function showConfirmationBox() {
    setShowConfirmation(!showConfirmation);
  }
  function removeFile() {
    const newFiles = fileId && uploadedFiles.filter(file => file.fileId !== fileId);
    setUploadedFiles(newFiles);
    showConfirmationBox();
  }

  const openFile = async (fileId: string, fileName: string) => {
    const api = fileApi + encodeURIComponent(fileId);
    const accessToken = await getAccessToken();

    if (Platform.OS === "web") {
      setViewerFileName(fileName);
      setIsViewerVisible(true);
      setViewerLoading(true);
      setViewerBlob(null);
      try {
        const response = await fetch(api, {
          headers: { 'Authorization': `Bearer ${accessToken}` }
        });
        if (!response.ok) {
          throw new Error(`Failed to fetch file: ${response.statusText}`);
        }
        const blob = await response.blob();
        setViewerBlob(blob);
      } catch (err) {
        console.error('Error opening file: ', err);
        setToastText("Failed to load file for preview.");
        setToastType('error');
        setToastVisibility(true);
        setIsViewerVisible(false);
      } finally {
        setViewerLoading(false);
      }
    } else {
      setFileLoad(true);
      downloadFile(api, accessToken, fileName);
    }
  }
  const downloadFile = async (url: string, token: string, fileName: string) => {

    if (Platform.OS === 'ios') {
      const { status } = await Permissions.askAsync(Permissions.MEDIA_LIBRARY);
      if (status !== 'granted') {
        alert('Sorry, we need camera roll permissions to make this work!');
      }
    } else if (Platform.OS === 'android') {
      const { status } = await Permissions.askAsync(Permissions.MEDIA_LIBRARY);
      if (status !== 'granted') {
        alert('Sorry, we need write storage permissions to make this work!');
      }
    }

    const uri = url;
    setFileType(uri.split('.').pop().toLowerCase());
    setDocType(uri.split('.').pop().toLowerCase());
    const fileUri = FileSystem.documentDirectory + fileName;
    let options = {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    };
    console.info('Trying to download ' + uri);
    console.info('Download Loc ' + fileUri);
    // FileSystem.downloadAsync(uri, fileUri, options)
    //   .then(({ uri }) => {
    //     console.log('Finished downloading to ', uri);
    //     setDownloadedFileUri(uri);
    //     showModal();
    //   })
    //   .catch(error => {
    //     console.error(error);
    //   });
    FileSystem.makeDirectoryAsync(FileSystem.documentDirectory, { intermediates: true })
      .then(() => {
        FileSystem.downloadAsync(uri, fileUri, options)
          .then(({ uri }) => {
            console.log('Finished downloading to ', uri);
            setDownloadedFileUri(uri);
            showModal();
            setFileLoad(false);
          })
          .catch(error => {
            console.error(error);
          });
      })
      .catch(error => {
        console.error('Error creating directory:', error);
      });
  }
  function submitClicked(status: string, handleSubmit: any) {
    handleSubmit();
  }
  function submitPressed() {
    handleSubmit(onSubmit, onError)();
  }
  function escalationPressed() {
    handleSubmit(onSubmit, onError)();
  }
  const GetLocation = async () => {

    try {
      const { status } = await Location.requestForegroundPermissionsAsync();
      console.log(status)
      if (status !== 'granted') {
        console.log('Permissions not granted!')
        setToastText("Permission denied to read location. Still you can manually enter location.")
        setToastVisibility(true);
        return;
      }
      const locationData = await Location.getCurrentPositionAsync();
      if (locationData.coords && locationData.coords.latitude && locationData.coords.longitude) {
        setLocationLink(JSON.stringify(locationData));

        if (locationData && locationData.coords && locationData.coords.latitude && locationData.coords.longitude) {
          //googleMapLink = locationData.coords.latitude && locationData.coords.longitude && `https://www.google.com/maps/search/?api=1&query=${locationData.coords.latitude},${locationData.coords.longitude}`;
          let googleMapLink = locationData.coords.latitude && locationData.coords.longitude && `Lattitude, Longitude: ${locationData.coords.latitude}, ${locationData.coords.longitude}`;
          setValue("Location", JSON.stringify(locationData));
        }

      } else {
        setToastText("Unable to read your location. Still you can manually enter location.")
        setToastVisibility(true);
      }
      //const googleMapLink = locationData.coords.latitude && locationData.coords.longitude && `https://www.google.com/maps?q=${locationData.coords.latitude},${locationData.coords.longitude}`;    
      //const googleMapLink = locationData.coords.latitude && locationData.coords.longitude && `https://www.google.com/maps/search/?api=1&query=${locationData.coords.latitude},${locationData.coords.longitude}`;

      console.info(JSON.stringify(locationData));
      // let updatedFields = (fields ?? []).map((f: any) => {
      //   if (f.key === "Location") {
      //     let googleMapLink;
      //     if (locationData && locationData.coords && locationData.coords.latitude && locationData.coords.longitude) {
      //       //googleMapLink = locationData.coords.latitude && locationData.coords.longitude && `https://www.google.com/maps/search/?api=1&query=${locationData.coords.latitude},${locationData.coords.longitude}`;
      //       googleMapLink = locationData.coords.latitude && locationData.coords.longitude && `Lattitude, Longitude: ${locationData.coords.latitude}, ${locationData.coords.longitude}`;
      //     }
      //     else {
      //       googleMapLink = locationData
      //     }
      //     return { ...f, "defaultValue": JSON.stringify(googleMapLink) };
      //   }
      //   return f;
      // });
      // setFields(updatedFields);
    }
    catch (error) {
      // Handle promise rejection
      console.error('An error occurred:', error);
    }
  }

  const GoToLocation = async () => {
    try {
      const locationData = JSON.parse(LocationLink);
      console.log(JSON.stringify(locationData));
      if (Platform.OS === 'android' || Platform.OS === 'ios') {
        const scheme = Platform.select({ ios: 'maps://0,0?q=', android: 'geo:0,0?q=' });
        const latLng = `${locationData.coords.latitude},${locationData.coords.longitude}`;
        const label = 'Observation Location';
        const url = Platform.select({
          ios: `${scheme}${label}@${latLng}`,
          android: `${scheme}${latLng}(${label})`
        });
        Linking.openURL(url);
      }
      else if (Platform.OS === 'web') {
        const googleMapLink = locationData.coords.latitude && locationData.coords.longitude && `https://www.google.com/maps/search/?api=1&query=${locationData.coords.latitude},${locationData.coords.longitude}`;
        window.open(googleMapLink, '_blank');
      }
    }
    catch (error) {
      // Handle promise rejection
      console.error('An error occurred:', error);
    }
  }
  const setEscalated = (val: boolean) => {
    escalated = val;
  }
  function getMiddleEllipsis(name: string, startChars = 12, endChars = 16) {
    if (!name) return "";

    // If already short enough, return as-is
    if (name.length <= startChars + endChars + 3) return name;

    const start = name.slice(0, startChars);
    const end = name.slice(-endChars);
    return `${start}…${end}`;
  }

  const fieldStyle = formMode === "View" ? formCustomStyles.fieldContianerViewMode : formCustomStyles.fieldContianer
  return (
    loadForm === false ? null :
      <View style={[{ marginLeft: Platform.OS === 'web' ? '10%' : 0, marginRight: Platform.OS === 'web' ? '10%' : 0, flex: 1 }]}>
        <Portal>
          <NotificationBanner
            visible={toastVisibility}
            message={toastText}
            type={toastType}
            onDismiss={handleToastDismiss}
            duration={3000}
          />
        </Portal>
        <ScrollView>

          <View style={[{ width: 200 }, styles.buttonsContainer]}>
            {fileResponse.map((file, index) => (
              <Text
                key={index.toString()}
                style={{}}
                numberOfLines={1}
                ellipsizeMode={'middle'}>
                {file?.uri}
              </Text>
            ))}
          </View>
          <View>
            <View style={{ margin: 10 }}>
              {showButtons === false ? null :

                formMode === "View"
                  ?
                  <View style={[{ flex: 1 }, styles.buttonsContainer]}><ButtonControl icon="close-circle-outline" mode="contained" onPress={handleClose} Title='Close' /></View>
                  :
                  <ScrollView horizontal>
                    <View style={styles.buttonsContainer}>
                      <View>
                        <View style={{ flex: 1 }}>
                          <ButtonControl icon="content-save-edit" mode="contained"
                            onPress={() => {
                              setEscalated(false);
                              handleSubmit(onSubmit, onError)()
                            }}
                            Title='Submit' />
                        </View>
                      </View>
                      <View>
                        {
                          ((props.Permissions) && (props.Permissions.includes('admin') || props.Permissions.includes('manage')) && formMode === "Edit") ?
                            <View style={{ flex: 1 }}><ButtonControl icon="content-save-edit" mode="contained"
                              onPress={() => {
                                setEscalated(true);
                                handleSubmit(onSubmit, onError)()
                              }}
                              Title='Escalate' /></View>
                            : null
                        }
                      </View>
                      <View style={{ flex: 1 }}><ButtonControl icon="close-circle-outline" mode="contained" onPress={handleClose} Title='Close' /></View>
                    </View>
                  </ScrollView>
              }

            </View>
            {/* <View style={{ borderWidth: 2, borderColor: '#DDDDDD', paddingLeft: 10 }}> */}
            <View style={{ paddingLeft: 10 }}>
              <View style={{ flexDirection: 'column' }}>
                {formMode === "View" ? null :
                  <View style={{ padding: 20 }}>
                    <DocPicker formMode={formMode} onFileUploaded={onFileUploaded} clientAPIURL={clientAPIURL} showWarning={setDocWarning} warningText={setWarningText} />
                  </View>
                }
                <View style={{ padding: 20, width: 240 }}>
                  {
                    formMode === "View" ? null :
                      Platform.OS === 'android' || Platform.OS === 'ios' ?
                        <ButtonControl icon='camera' mode="contained" onPress={() => setCamVisible(true)} Title='Camera' />
                        : null
                  }
                </View>
                {docWarning === true ?
                  <View>
                    <Text style={{ color: 'red' }}>{warningText}</Text>
                  </View>
                  : null}
              </View>
              <View style={{ paddingLeft: 20 }}>

                {uploadedFiles.map((file: { fileId: string, fileName: string }, index) => (
                  <View key={index} style={{ flexDirection: "row", alignItems: "center", height: 50, gap: 8 }}>
                    <TouchableOpacity
                      onPress={() => openFile(file.fileId, file.fileName)}
                      style={{ flex: 1, minWidth: 0 }}
                      disabled={formMode === "New"}
                    >
                      <Text style={{ marginRight: 10 }}>
                        {index + 1}: <Text style={{ color: formMode === "New" ? '#333' : 'blue', textDecorationLine: formMode === "New" ? 'none' : 'underline' }} numberOfLines={1}>
                          {getMiddleEllipsis(file.fileName, 14, 18)}
                        </Text>
                      </Text>
                    </TouchableOpacity>

                    {formMode !== "View" && (
                      <View style={{ flexShrink: 0 }}>
                        <Tooltip title="Remove attachment">
                          <IconButton
                            icon="close-circle-outline"
                            iconColor={MD3Colors.error50}
                            size={20}
                            onPress={() => confirmDelete(file.fileId)}
                          />
                        </Tooltip>
                      </View>
                    )}
                  </View>
                ))}
                {/* {showConfirmation && (
                  <View>

                    <ConfirmBox title={"Confirmation"}
                      message={"Are you sure you want to proceed to delete selected items?"}
                      yesCallback={removeFile}
                      noCallback={showConfirmationBox} />

                  </View>
                )} */}
                {showConfirmation && (
                  <ConfirmTop
                    visible={showConfirmation}
                    title="Delete Attachment"
                    message="Are you sure you want to permanently delete this attachment? This action cannot be undone."
                    onYes={removeFile}
                    onNo={showConfirmationBox}
                    yesText="Delete"
                    noText="Cancel"
                  />
                )}
              </View>
              <View style={{ padding: 10 }}></View>
            </View>
          </View>

          {/* <View style={formCustomStyles.allFieldsContainer}> */}
          <View style={{}}>
            {fields
              .filter((field) => isFieldApplicable(field, _observationType, _closedOut))
              .map((field, index) => {

                if (field.hidden === true) {
                  return null
                }
                else {
                  if (field.key === "EscalationNote") {
                    return ((props.Permissions) && (props.Permissions.includes('admin') || props.Permissions.includes('manage')) && (formMode === 'Edit' || formMode === 'View')) ?
                      <View key={index} nativeID={`field-${field.key}`} style={[fieldStyle]}>
                        <TextField
                          key={field.key.toString()}
                          editable={formMode === 'View' ? false : true}
                          field={field}
                          control={control}
                          styles={styles.input}
                          Ctrl={Controller}
                          errors={errors}
                        //ref={register}
                        /></View>
                      : null
                  }
                  if (field.key === "Location") {
                    return (
                      <View key={index} nativeID={`field-${field.key}`} style={[fieldStyle]}>
                        <View key={index} style={{ flexDirection: 'column' }}>
                          <View>
                            <LocationField
                              key={field.key.toString()}
                              editable={formMode === 'View' ? false : true}
                              field={field}
                              control={control}
                              styles={styles.input}
                              Ctrl={Controller}
                              errors={errors}
                              userTypedLocation={userTypedLocation}
                            />

                          </View>
                          <View style={{ height: 70, padding: 10, alignItems: 'flex-start' }}>
                            <View style={{ flex: 1, flexDirection: 'row', gap: 20 }}>
                              {formMode === "View" ? null :
                                <TouchableOpacity onPress={() => GetLocation()} style={styles.locationIconHolder}>
                                  <Tooltip title="Get live location">
                                    <IconButton
                                      icon="map-marker-plus-outline"
                                      iconColor={MD3Colors.error10}
                                      size={20}
                                      onPress={() => GetLocation()}
                                    />
                                  </Tooltip>
                                </TouchableOpacity>
                              }
                              {/* <View style={{ flex: 1, alignContent: 'center', justifyContent: 'center' }}> */}
                              {
                                LocationLink && LocationLink !== null && LocationLink.includes('coords') ?
                                  <TouchableOpacity onPress={() => GoToLocation()} style={styles.locationIconHolder}>
                                    <Tooltip title="Open Location">
                                      <IconButton
                                        icon="map-marker-path"
                                        iconColor={MD3Colors.error10}
                                        size={20}
                                        onPress={() => GoToLocation()}
                                      />
                                    </Tooltip>
                                  </TouchableOpacity>
                                  : null
                              }
                              {/* </View> */}
                              {formMode === "View" ? null :
                                <TouchableOpacity onPress={() => ClearLocationText()} style={styles.locationIconHolder}>
                                  <Tooltip title="Clear Location Text">
                                    <IconButton
                                      icon="close-circle-outline"
                                      iconColor={MD3Colors.error50}
                                      size={20}
                                      onPress={() => ClearLocationText()}
                                    />
                                  </Tooltip>
                                </TouchableOpacity>
                              }
                            </View>
                          </View>
                        </View>
                      </View>
                    )
                  }
                  if (field.key === "Comments") {
                    return (
                      <View key={index} nativeID={`field-${field.key}`} style={[fieldStyle]}>
                        {formMode === "View" ? null : (
                          <TextField
                            key="NewComment"
                            editable={true}
                            field={{ ...field, key: 'NewComment', label: 'Add Comment', multiline: true, defaultValue: '' }}
                            control={control}
                            styles={styles.input}
                            Ctrl={Controller}
                            errors={errors}
                            logTitle={props.logTitle}
                          />
                        )}
                        {!!field.defaultValue && (
                          <View style={{ marginTop: formMode === "View" ? 0 : 8 }}>
                            <Text style={{ fontWeight: 'bold', fontSize: 16 }}>Comment History</Text>
                            <View style={{ borderWidth: 1, borderColor: '#DDDDDD', borderRadius: 5, padding: 10, marginTop: 5, backgroundColor: '#FAFAFA' }}>
                              <Text style={{ fontSize: 13 }}>{field.defaultValue}</Text>
                            </View>
                          </View>
                        )}
                      </View>
                    );
                  }
                  switch (field.subType) {
                    case 'text':
                      return (
                        // <Text>{field.key}</Text>
                        <View key={index} nativeID={`field-${field.key}`} style={[fieldStyle]}>
                          <TextField
                            key={field.key.toString()}
                            editable={formMode === 'View' ? false : true}
                            field={field}
                            control={control}
                            styles={styles.input}
                            Ctrl={Controller}
                            errors={errors}
                            logTitle={props.logTitle}
                          //ref={register}
                          /></View>
                      );
                    case 'choice':
                      return (
                        field.key === "RootCause" ?
                          <View key={index} nativeID={`field-${field.key}`} style={[fieldStyle]}>
                            <ReactDropdownMultiSelect
                              field={field}
                              key={field.key.toString()}
                              editable={formMode === 'View' ? false : true}
                              control={control}
                              Ctrl={Controller}
                              errors={errors}
                            />
                          </View>
                          :
                          <View key={index} nativeID={`field-${field.key}`} style={[fieldStyle]}>
                            <ReactDropdownSingleSelect
                              field={field}
                              key={field.key.toString()}
                              editable={formMode === 'View' ? false : true}
                              control={control}
                              Ctrl={Controller}
                              errors={errors}
                            />
                          </View>
                      );
                    case 'float':
                      return (
                        // <Text>{field.key}</Text>
                        <View key={index} nativeID={`field-${field.key}`} style={[fieldStyle]}>
                          <NumberField
                            key={field.key.toString()}
                            editable={formMode === 'View' ? false : true}
                            field={field}
                            control={control}
                            styles={styles.input}
                            Ctrl={Controller}
                            errors={errors}
                          //ref={register}
                          />
                        </View>
                      );
                    case 'integer':
                      return (
                        // <Text>{field.key}</Text>
                        <View key={index} nativeID={`field-${field.key}`} style={[fieldStyle]}>
                          <NumberField
                            key={field.key.toString()}
                            editable={formMode === 'View' ? false : true}
                            field={field}
                            control={control}
                            styles={styles.input}
                            Ctrl={Controller}
                            errors={errors}
                          //ref={register}
                          />
                        </View>
                      );
                    case 'date':
                      return (
                        // <Text>{field.key}</Text>
                        <View key={index} nativeID={`field-${field.key}`} style={[fieldStyle, { zIndex: 1 }]}>
                          <PaperDates
                            key={field.key.toString()}
                            field={field}
                            editable={formMode === 'View' ? false : true}
                            control={control}
                            styles={styles.date}
                            Ctrl={Controller}
                            errors={errors}
                          //ref={register}
                          />
                        </View>
                      );

                    default:
                      return null
                  }
                }
              }
              )}


          </View>
          <View style={{ margin: 10 }}>
            {showButtons === false ? null :
              formMode === "View"
                ?
                <View style={[{ flex: 1 }, styles.buttonsContainer]}><ButtonControl icon="close-circle-outline" mode="contained" onPress={handleClose} Title='Close' /></View>
                :
                <ScrollView horizontal>
                  <View style={styles.buttonsContainer}>
                    <View>
                      <View style={{ flex: 1 }}>
                        <ButtonControl icon="content-save-edit" mode="contained"
                          onPress={() => {
                            setEscalated(false);
                            handleSubmit(onSubmit, onError)()
                          }}
                          Title='Submit' />
                      </View>
                    </View>
                    <View>
                      {
                        ((props.Permissions) && (props.Permissions.includes('admin') || props.Permissions.includes('manage')) && formMode === "Edit") ?
                          <View style={{ flex: 1 }}><ButtonControl icon="content-save-edit" mode="contained"
                            onPress={() => {
                              setEscalated(true);
                              handleSubmit(onSubmit, onError)()
                            }}
                            Title='Escalate' /></View>
                          : null
                      }
                    </View>
                    <View style={{ flex: 1 }}><ButtonControl icon="close-circle-outline" mode="contained" onPress={handleClose} Title='Close' /></View>
                  </View>
                </ScrollView>
            }
          </View>
        </ScrollView>
        <AttachmentViewerModal
          visible={isViewerVisible}
          onClose={() => setIsViewerVisible(false)}
          fileName={viewerFileName}
          blob={viewerBlob}
          loading={viewerLoading}
        />
      </View>


  );
});

const styles = StyleSheet.create({
  container: {
    //justifyContent: 'center',
    //alignItems: 'center',
    paddingLeft: '5%',
    paddingRight: '5%',

    flex: 1,
    padding: 16,
    gap: 20,
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
  toastOverlay: {
    position: 'absolute',
    bottom: 20,      // stick 20px above bottom of screen
    left: 0,
    right: 0,
    alignItems: 'center', // center the toast
    zIndex: 9999,    // make sure it appears above everything
  },
  formContainerPC: {
    paddingLeft: '25%',
    paddingRight: '25%',
  },
  formContainerMobile: {
    borderWidth: 0.5, // Set the border width
    borderColor: 'gray', // Set the border color
    borderRadius: 5, // Set the border radius (optional)

    shadowColor: 'blue', // Set the shadow color
    shadowOffset: { width: 0, height: 2 }, // Set the shadow offset
    shadowOpacity: 0.5, // Set the shadow opacity
    shadowRadius: 4, // Set the shadow radius
    elevation: 4,
    //marginLeft: '5%',
    //marginRight: '5%',
    //paddingLeft: 5,
    //paddingRight: 5,
    backgroundColor: '#FFFFFF'
  },
  locationIconHolder: {
    shadowColor: 'rgba(0,0,0, .4)',
    shadowOffset: { height: 3, width: 1 },
    borderRadius: 50,
    shadowOpacity: 1,
    shadowRadius: 5,
    backgroundColor: '#fff',
    elevation: 5,
    height: 40,
    width: 40,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
  },
  input: {
    backgroundColor: 'transparent',
    marginVertical: 5,
    marginBottom: 30,
    borderWidth: 1,
    //borderWidth: 0.5, // Set the border width
    borderColor: 'gray', // Set the border color
    borderRadius: 5, // Set the border radius (optional)
    shadowColor: 'blue', // Set the shadow color
    shadowOffset: { width: 0, height: 2 }, // Set the shadow offset
    shadowOpacity: 0.5, // Set the shadow opacity
    shadowRadius: 4, // Set the shadow radius
    elevation: 4,
    minHeight: 60,
    //maxHeight: 60,
  },
  date: {
    minWidth: '100%',
    minHeight: 60,
    maxHeight: 60,

    backgroundColor: 'transparent',
    marginVertical: 5,
    marginBottom: 30,
    borderWidth: 1,
    //borderWidth: 0.5, // Set the border width
    borderColor: 'gray', // Set the border color
    borderRadius: 5, // Set the border radius (optional)
    shadowColor: 'blue', // Set the shadow color
    shadowOffset: { width: 0, height: 2 }, // Set the shadow offset
    shadowOpacity: 0.5, // Set the shadow opacity
    shadowRadius: 4, // Set the shadow radius
    elevation: 4
  },
  buttonsContainer: {
    flex: 1,
    //padding: 16,
    gap: 20,
    flexDirection: 'row',
    flexWrap: 'wrap',
    //alignItems: 'center',
    //justifyContent: 'space-evenly',
    height: 60
  }
});

export default WebObservationForm;
